<template>
<div class="chapter">
<div class="inner_page">
<p class="part-title"><a id="p01"></a><span>Lonesome Rider</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?368c0718